import { render, staticRenderFns } from "./LinkedTransactionsModal.vue?vue&type=template&id=dbb57d88&scoped=true&"
import script from "./LinkedTransactionsModal.vue?vue&type=script&lang=js&"
export * from "./LinkedTransactionsModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkedTransactionsModal.vue?vue&type=style&index=0&id=dbb57d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb57d88",
  null
  
)

export default component.exports